import { createFileRoute } from "@tanstack/react-router";
import { Navigate } from "@/lib/router-compat";
import { useAuth } from "@/contexts/AuthContext";

export const Route = createFileRoute("/")({
  head: () => ({ meta: [
    { title: "Thiia — Votre espace" },
    { name: "description", content: "Retrouvez votre espace Thiia." },
    { property: "og:title", content: "Thiia — Votre espace" },
    { property: "og:description", content: "Retrouvez votre espace Thiia." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" },
  ] }),
  component: SmartRedirect,
});

function BootFallback() {
  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center px-6">
      <div className="flex items-center gap-3 text-sm text-muted-foreground">
        <div className="h-4 w-4 rounded-full border-2 border-primary border-t-transparent animate-spin" />
        <span>Chargement de Thiia…</span>
      </div>
    </div>
  );
}

function SmartRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <BootFallback />;
  return <Navigate to={user ? "/chat" : "/landing"} replace />;
}
